import { render, staticRenderFns } from "./KitwareLogoIcon.vue?vue&type=template&id=5c130a7c&scoped=true&svg=true&"
import script from "./KitwareLogoIcon.vue?vue&type=script&lang=js&"
export * from "./KitwareLogoIcon.vue?vue&type=script&lang=js&"
import style0 from "./KitwareLogoIcon.vue?vue&type=style&index=0&id=5c130a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c130a7c",
  null
  
)

export default component.exports